import Domain from 'helpers/Domain';

export default {
    methods: {
        getCurrencySymbol(fallbackSymbol) {
            let symbol = fallbackSymbol;
            const configElement =
                document.getElementById('app-config') ?? document.getElementById('php-to-js-var');
            if (configElement) {
                symbol = JSON.parse(configElement.innerHTML)?.currencySymbol;
            }
            return symbol;
        },
        pricePrettyPrint(
            numberValue,
            symbol,
            currencyCode,
            language = CBS.Registry.region.locale,
            displayCurrencyCode = !!Domain.isInternational(),
        ) {
            // latam uses the same currency formatting as BR because Intl.Numberformat does not support es-419
            // Also MXN does not follow the same formatting as the rest of latam
            if (language === 'es-419' && currencyCode !== 'MXN') {
                language = 'pt-BR';
            }
            const currencySymbol = this.getCurrencySymbol(symbol || '');
            let n = this.normalizePrice(numberValue);
            if (n === numberValue.toString()) {
                // In the event that n didn't change we fallback to the original set-up before normalizePrice was added
                n = n.replace(/[^0-9.]+/g, '');
            }

            let formattedVal = Intl.NumberFormat(language, {
                style: 'currency',
                currency: currencyCode.trim(),
            }).format(n);
            formattedVal = formattedVal.match(/[\d.,]+/g)[0];

            let prettyPrice = `${currencySymbol}${formattedVal}`;

            if (displayCurrencyCode) {
                prettyPrice += ` ${currencyCode}`;
            }
            return prettyPrice;
        },
        /** Normalize Price needs to get remove commas and periods, and then use the known currencySubunits to reinsert the period
         * -- Note-- this method may not work for currencies using 1000 for their currencySubunits. This is a severe edge case and unlikely to come up.
         * --   Currently we only support currencies that use 100 or 1(None) as their currencySubunits.
         * @param {string} price - The price to normalize
         * @returns {string} - The price normalized into a better format, or the original value converted to a string
         */
        normalizePrice(price) {
            const configElement =
                document.getElementById('app-config') ?? document.getElementById('php-to-js-var');
            const JSONConfig = configElement?.innerHTML ? JSON.parse(configElement.innerHTML) : {};
            const currencySubunits = JSONConfig?.currencySubunits || 100; // Default to 100 for most currencies;
            // Remove all non-number value related characters
            let normalizedPrice = price.toString().replace(/[^0-9,.]+/g, '');
            let needToDivide = false;
            let divisor = currencySubunits;
            const separatorsPresent = normalizedPrice.match(/[^0-9]/g);
            if (separatorsPresent) {
                const subUnitPlaces = Math.log10(currencySubunits);
                const lastSeparator = separatorsPresent[separatorsPresent.length - 1];
                if (
                    normalizedPrice.lastIndexOf(lastSeparator) ==
                    normalizedPrice.length - (subUnitPlaces + 1)
                ) {
                    // If the last separator is the same distance away as the currencySubunits, we assume that we need to divide
                    needToDivide = true;
                } else if (
                    subUnitPlaces == 0 &&
                    normalizedPrice.lastIndexOf(lastSeparator) == normalizedPrice.length - 3
                ) {
                    // If the currencySubunits is 1, and the last separator is 2 away from the end of the string, we need to divide and override the divisor
                    needToDivide = true;
                    divisor = 100;
                }
            }
            // Remove all non-numeric characters
            normalizedPrice = parseInt(normalizedPrice.replace(/[^0-9]+/g, ''));
            if (isNaN(normalizedPrice)) {
                return price.toString();
            }
            // If there were separators present, we need to divide by the currencySubunits
            if (needToDivide) {
                normalizedPrice = normalizedPrice / divisor;
            }
            return normalizedPrice.toString();
        },
    },
};
